import UserManagementDropDown from '../TrialUI/DataTableDropdowns/UserManagementDropDown'

export default {
  tabs: {
    users: {
      title: 'User Management',
      fetchKey: 'users',
      headers: [
        'name',
        'email',
        'phoneNumber',
        'role',
        // 'studyTeams',
        // 'community',
        // 'marketing',
        'appAccess',
        // 'instance',
        // 'trials',
        // 'affiliation',
        // 'division'
      ],
      dropdown: UserManagementDropDown
    }
  },
  app: {
    'xt_screen': 'XpertScreen',
    'xt_console': 'Admin-Console',
    // 'xperttrial': 'XpertTrial',
    'xt_dashboard': 'Admin-Dashboard'
  }
}
